module.exports = __webpack_public_path__ + "static/7.3928817b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MasterTheses/7.png
// module id = 829
// module chunks = 39236203315009 172526442442348